import { colors } from "@dotnet/telematics-design-system";

import { StyleOptions } from "./types";

export const styleOptions: StyleOptions = {
  colors: {
    primary: {
      text: colors.white,
      background: {
        rest: colors.blue700,
        hover: colors.blue800,
        active: colors.blue900
      },
      loader: colors.white
    },
    primarySubtle: {
      text: colors.blue700,
      background: {
        rest: colors.blue100,
        hover: colors.blue200,
        active: colors.blue400
      },
      loader: colors.blue700
    },
    secondary: {
      text: colors.textDark,
      background: {
        rest: colors.gray100,
        hover: colors.gray200,
        active: colors.gray300
      },
      loader: colors.textDark
    },
    white: {
      text: colors.gray700,
      background: {
        rest: colors.white,
        hover: colors.gray200,
        active: colors.gray300
      },
      loader: colors.gray700
    },
    modalWhite: {
      text: colors.textPrimaryBlue,
      background: {
        rest: colors.white,
        hover: colors.gray200,
        active: colors.gray300
      },
      loader: colors.textPrimaryBlue
    },
    transparent: {
      text: colors.white,
      background: {
        rest: "rgba(255, 255, 255, 0.05)",
        hover: "rgba(255, 255, 255, 0.1)",
        active: "rgba(255, 255, 255, 0.12)"
      },
      loader: colors.white
    },
    critical: {
      text: colors.white,
      background: {
        rest: colors.red700,
        hover: colors.red800,
        active: colors.red900
      },
      loader: colors.white
    },
    criticalSubtle: {
      text: colors.red800,
      background: {
        rest: colors.red100,
        hover: colors.red200,
        active: colors.red300
      },
      loader: colors.red800
    }
  },
  paddings: {
    textOnly: {
      tiny: "4px 8px",
      small: "8px 12px",
      normal: "12px 16px",
      large: "15px 24px"
    },
    iconLeft: {
      tiny: "4px 8px 4px 4px",
      small: "6px 12px 6px 8px",
      normal: "10px 16px 10px 12px",
      large: "14px 24px 14px 16px"
    },
    iconRight: {
      tiny: "4px 4px 4px 8px",
      small: "6px 8px 6px 12px",
      normal: "10px 12px 10px 16px",
      large: "14px 16px 14px 24px"
    },
    twoIcons: {
      tiny: "4px",
      small: "6px 8px",
      normal: "10px 12px",
      large: "14px 16px"
    },
    iconOnly: {
      tiny: "4px",
      small: "6px",
      normal: "10px",
      large: "14px"
    }
  },
  typography: {
    tiny: {
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.4px"
    },
    small: {
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.1px"
    },
    normal: {
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.1px"
    },
    large: {
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "0.15px"
    }
  }
};
